import store from '@/store'
import ModuleBase from '../components/ModuleBase'
import SoftwareDashboard from '../views/Dashboard'


const routes = [
  {
    path: '/software/',
    component: ModuleBase,
    meta: { appKey: 'softwareprojects' },
    children: [
      {
        path: 'dashboard',
        component: SoftwareDashboard,
        name: 'SoftwareDashboard',
        beforeEnter: (to, from, next) => {
          store.dispatch('clearSubnav')
          next()
        }
      // },
      // {
      //   path: 'details/:id/',
      //   component: DetailBase,
      //   children: [
      //     {
      //       path: 'overview',
      //       name: 'IrrigationFieldDetailOverview',
      //       component: IrrigationFieldDetailOverview
      //     },
      //     // {
      //     //   path: 'parts-list',
      //     //   name: 'IrrigationPartsList',
      //     //   component: IrrigationPartsList
      //     // }
      //   ]
      }
    ]
  }
]

export default routes
